import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class CoordinationsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // DECLINE //
  declineSuccess() {
    const message = {
      body: 'COORDINATION_DECLINE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  declineError() {
    const message = {
      body: 'COORDINATION_DECLINE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE SERVICE//
  createServiceSuccess() {
    const message = {
      body: 'COORDINATION_CREATE_SERVICE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createServiceError() {
    const message = {
      body: 'COORDINATION_CREATE_SERVICE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE SERVICES//
  createServicesSuccess() {
    const message = {
      body: 'COORDINATION_CREATE_SERVICES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createServicesError() {
    const message = {
      body: 'COORDINATION_CREATE_SERVICES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE SERVICE //
  updateServiceSuccess() {
    const message = {
      body: 'COORDINATION_UPDATE_SERVICE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateServiceError() {
    const message = {
      body: 'COORDINATION_UPDATE_SERVICE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  declineServicesSuccess() {
    const message = {
      body: 'COORDINATION_DECLINE_SERVICES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  declineServicesError() {
    const message = {
      body: 'COORDINATION_DECLINE_SERVICES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND SMS TO SERVICES //
  sendSMSToServicesSuccess() {
    const message = {
      body: 'COORDINATION_SEND_SMS_TO_SERVICES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendSMSToServicesError() {
    const message = {
      body: 'COORDINATION_SEND_SMS_TO_SERVICES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SEND SMS TO MANY SERVICES //
  sendSMSToManyServicesSuccess() {
    const message = {
      body: 'COORDINATION_SEND_SMS_TO_MANY_SERVICES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  sendSMSToManyServicesError() {
    const message = {
      body: 'COORDINATION_SEND_SMS_TO_MANY_SERVICES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // OUT OF SERVICE ZONE //
  outOfServiceZoneError() {
    const message = {
      body: 'COORDINATION_OUT_OF_SERVICE_ZONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // NO VALID PAYMENT METHOD //
  noValidPaymentMethodError() {
    const message = {
      body: 'COORDINATION_NO_VALID_PAYMENT_METHOD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE COORDINATION //
  createCoordinationSuccess() {
    const message = {
      body: 'COORDINATION_CREATE_COORDINATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createCoordinationError() {
    const message = {
      body: 'COORDINATION_CREATE_COORDINATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPLOAD_FILE //
  uploadFileError() {
    const message = {
      body: 'COORDINATION_UPLOAD_FILE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.coordinations')
  .service('coordinationsAlerts', CoordinationsAlerts);
